export default __webpack_public_path__ + "static/media/Coffee.22eab87c.svg";